import { atom } from 'jotai';
import { createMutationAtom } from 'atoms/create-resource-atom';
import type {
  InventoryWorkspacePromotionPlanResponse,
  PromoteInventoryWorkspaceResponse,
} from 'types/api-responses';

// Which drawer the right sidebar shows: the workspace verification tasks, the
// DCA scenario picker the details content's charts key on, or the workspace-gate
// verdict decision panel (Mark as Correct/Incorrect + reason).
export type InventoryWorkspaceRightPanel =
  | { type: 'none' }
  | { type: 'workspace-tasks' }
  | { type: 'dca' }
  | { type: 'verification'; kind: 'correct' | 'incorrect' };

export const inventoryRightPanelAtom = atom<InventoryWorkspaceRightPanel>({
  type: 'none',
});

// Promote flow — the read-only plan preview, then the promote itself. Both take
// the same `workspace` envelope; see the payload registry for the shapes.
export const inventoryPromotionPlanAtom = createMutationAtom<
  InventoryWorkspacePromotionPlanResponse,
  'inventoryWorkspacePromotionPlan'
>();

export const promoteInventoryWorkspaceAtom = createMutationAtom<
  PromoteInventoryWorkspaceResponse,
  'promoteInventoryWorkspace'
>();
